import { render, staticRenderFns } from "./UserGuide.vue?vue&type=template&id=44c00cfc&"
import script from "./UserGuide.vue?vue&type=script&lang=ts&"
export * from "./UserGuide.vue?vue&type=script&lang=ts&"
import style0 from "./UserGuide.vue?vue&type=style&index=0&id=44c00cfc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports